module.exports = __webpack_public_path__ + "static/images/score-tip.5775434.png";